import { transformUrlProxy, SLD } from '@patsnap-utils/biz';

export const PASSPORT_URI = transformUrlProxy(SLD.PASSPORT, import.meta.env.VITE_PASSPORT_URI);

export const CORE_BASIC_SERVICE_URI = import.meta.env.VITE_CORE_BASIC_SERVICE_URI;
export const CORE_SEARCH_SERVICE_URI = import.meta.env.VITE_CORE_SEARCH_SERVICE_URI;
export const EUREKA_SERVICE_URI = import.meta.env.VITE_EUREKA_SERVICE_URI;
export const LAB_SERVICE_URI = import.meta.env.VITE_LAB_SERVICE_URI;
export const STATIC_COMMON_URL = import.meta.env.VITE_STATIC_COMMON_URL;
export const ACCOUNT_SERVICE_URI = import.meta.env.VITE_ACCOUNT_SERVICE_URI;
export const WORKSPACE_URI = import.meta.env.VITE_WORKSPACE_URI;
export const WORKSPACE_SERVICE_URI = import.meta.env.VITE_WORKSPACE_SERVICE_URI;
